import { render, staticRenderFns } from "./PaymentsFluxDetailPage.vue?vue&type=template&id=2fa67b2e&"
import script from "./PaymentsFluxDetailPage.vue?vue&type=script&lang=js&"
export * from "./PaymentsFluxDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fa67b2e')) {
      api.createRecord('2fa67b2e', component.options)
    } else {
      api.reload('2fa67b2e', component.options)
    }
    module.hot.accept("./PaymentsFluxDetailPage.vue?vue&type=template&id=2fa67b2e&", function () {
      api.rerender('2fa67b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/detailPages/PaymentsFluxDetailPage.vue"
export default component.exports